import {
  currentOrPastDateUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['vet-info--date-of-birth-title'];
const INPUT_LABEL = content['vet-info--date-of-birth-label'];

const { veteranDateOfBirth } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    veteranDateOfBirth: currentOrPastDateUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    required: ['veteranDateOfBirth'],
    properties: { veteranDateOfBirth },
  },
};
